"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UIInputStaticLabel = _interopRequireDefault(require("../input/UIInputStaticLabel"));

var _UITextInput = _interopRequireDefault(require("../input/UITextInput"));

var _UIStepperInput = _interopRequireDefault(require("../input/UIStepperInput"));

var _UIColorSwatch = _interopRequireDefault(require("./UIColorSwatch"));

var CustomRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _passthroughProps = _interopRequireDefault(require("../utils/propTypes/passthroughProps"));

var Color = _interopRequireWildcard(require("../utils/propTypes/color"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _colors = require("HubStyleTokens/colors");

var _ColorPickerShim = _interopRequireDefault(require("./ColorPickerShim"));

var _UIPopover = _interopRequireDefault(require("../tooltip/UIPopover"));

var _UIFormControl = _interopRequireDefault(require("../form/UIFormControl"));

var DEFAULT_COLOR = '';

var isEmptyState = function isEmptyState(color) {
  return color === DEFAULT_COLOR || color === null || color === '#';
};

var prependHexChar = function prependHexChar(color) {
  return color[0] === '#' ? color : "#" + color;
};

var getDisplayColor = function getDisplayColor(color) {
  return (color || '').replace('#', '');
};

var getSwatchColor = function getSwatchColor(color) {
  var lastColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _colors.OLAF;
  if (isEmptyState(color)) return _colors.OLAF;

  if (color.length > 4 && color.length < 7) {
    return color.slice(0, 4);
  }

  return color.length <= 3 ? lastColor : color;
};

var shouldShowBorder = function shouldShowBorder(color) {
  var value = color.toLowerCase();

  var olaf = _colors.OLAF.toLowerCase();

  return isEmptyState(value) || value === olaf || olaf.indexOf(value) === 0 && value.length > 3;
};

var NoopColorPicker = function NoopColorPicker() {
  return _react.default.createElement("span", null);
};

var renderColorPickerPanel = function renderColorPickerPanel(computedColorPicker, open, swatchColor, opacity, handleColorChange, handleOpenChange, popoverTarget) {
  if (!open && computedColorPicker !== 'native' || computedColorPicker === NoopColorPicker) return null;
  var body = CustomRenderer.render(typeof computedColorPicker === 'function' ? computedColorPicker : _ColorPickerShim.default, {
    open: open,
    hexOnly: false,
    color: swatchColor,
    alpha: opacity,
    onChange: handleColorChange,
    mode: 'RGB',
    includeAlpha: Boolean(opacity)
  });
  return computedColorPicker === 'native' ? body : _react.default.createElement(_UIPopover.default, {
    autoPlacement: "horiz",
    className: "private-color-input__picker",
    content: {
      body: body
    },
    closeOnOutsideClick: true,
    onOpenChange: handleOpenChange,
    open: open,
    placement: "right",
    target: popoverTarget
  });
};

var UIColorInput =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UIColorInput, _React$Component);

  function UIColorInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIColorInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIColorInput).call(this, props));
    _this.state = {
      swatchColor: getSwatchColor(_this.props.color)
    };
    _this._renderColorPickerPanel = (0, _memoizeOne.default)(renderColorPickerPanel);
    _this.handleColorChange = _this.handleColorChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInputChange = _this.handleInputChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOpacityInputChange = _this.handleOpacityInputChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOpenChange = _this.handleOpenChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UIColorInput, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var nextColor = _ref.color;
      this.setState({
        swatchColor: getSwatchColor(nextColor, this.state.swatchColor)
      });
    }
  }, {
    key: "handleColorChange",
    value: function handleColorChange(evt) {
      var _this$props = this.props,
          onColorChange = _this$props.onColorChange,
          onOpacityChange = _this$props.onOpacityChange,
          opacity = _this$props.opacity;

      if (opacity && evt.alpha) {
        onOpacityChange(evt.target ? evt : (0, _SyntheticEvent.default)(evt.alpha));
      }

      onColorChange(evt.target ? evt : (0, _SyntheticEvent.default)(evt.color));
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(_ref2) {
      var value = _ref2.target.value;
      var _this$props2 = this.props,
          colorValidator = _this$props2.colorValidator,
          readOnly = _this$props2.readOnly;
      if (readOnly) return;

      if (colorValidator(value)) {
        if (!value) {
          this.handleColorChange((0, _SyntheticEvent.default)(null));
        } else {
          this.handleColorChange((0, _SyntheticEvent.default)(prependHexChar(value)));
        }
      }
    }
  }, {
    key: "handleOpacityInputChange",
    value: function handleOpacityInputChange(evt) {
      var _this$props3 = this.props,
          onOpacityChange = _this$props3.onOpacityChange,
          readOnly = _this$props3.readOnly;
      if (readOnly) return;
      onOpacityChange(evt);
    }
  }, {
    key: "handleOpenChange",
    value: function handleOpenChange() {
      var _this$props4 = this.props,
          onOpenChange = _this$props4.onOpenChange,
          open = _this$props4.open;
      onOpenChange((0, _SyntheticEvent.default)(!open));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          className = _this$props5.className,
          ColorPicker = _this$props5.ColorPicker,
          color = _this$props5.color,
          __colorValidator = _this$props5.colorValidator,
          disabled = _this$props5.disabled,
          id = _this$props5.id,
          inputClassName = _this$props5.inputClassName,
          inputProps = _this$props5.inputProps,
          __onColorChange = _this$props5.onColorChange,
          __onOpacityChange = _this$props5.onOpacityChange,
          __onOpenChange = _this$props5.onOpenChange,
          opacityInputClassName = _this$props5.opacityInputClassName,
          opacityInputLabel = _this$props5.opacityInputLabel,
          opacityInputProps = _this$props5.opacityInputProps,
          open = _this$props5.open,
          readOnly = _this$props5.readOnly,
          swatchClassName = _this$props5.swatchClassName,
          swatchProps = _this$props5.swatchProps,
          opacity = _this$props5.opacity,
          colorInputLabel = _this$props5.colorInputLabel,
          showInput = _this$props5.showInput,
          rest = (0, _objectWithoutProperties2.default)(_this$props5, ["className", "ColorPicker", "color", "colorValidator", "disabled", "id", "inputClassName", "inputProps", "onColorChange", "onOpacityChange", "onOpenChange", "opacityInputClassName", "opacityInputLabel", "opacityInputProps", "open", "readOnly", "swatchClassName", "swatchProps", "opacity", "colorInputLabel", "showInput"]);
      var swatchColor = this.state.swatchColor;
      var computedColorPicker = readOnly || disabled ? NoopColorPicker : ColorPicker;
      var classes = (0, _classNames.default)('private-color-input', className, {
        'private-color-input--opacity': opacity != null
      });
      var swatchClasses = (0, _classNames.default)('private-color-input__swatch', swatchClassName, {
        'private-color-input__swatch--noop': computedColorPicker === NoopColorPicker,
        'private-color-input__swatch--disabled': disabled
      });
      var renderedHexInput = disabled ? _react.default.createElement(_UITextInput.default, (0, _extends2.default)({}, inputProps, {
        className: (0, _classNames.default)('private-color-input__control', inputClassName),
        id: id,
        disabled: true,
        value: "#" + getDisplayColor(color)
      })) : _react.default.createElement(_UIInputStaticLabel.default, {
        text: "#"
      }, _react.default.createElement(_UITextInput.default, (0, _extends2.default)({}, inputProps, {
        className: (0, _classNames.default)('private-color-input__control', inputClassName),
        id: id,
        maxLength: 7,
        onChange: this.handleInputChange,
        spellCheck: "false",
        value: getDisplayColor(color),
        readOnly: readOnly
      })));
      var showOpacityInput = typeof opacity !== 'undefined' && showInput;
      var renderedOpacityInput = showOpacityInput ? _react.default.createElement(_UIFormControl.default, {
        "aria-label": opacityInputLabel || 'opacity input',
        label: opacityInputLabel,
        className: "private-color-input__opacity-input"
      }, _react.default.createElement(_UIStepperInput.default, (0, _extends2.default)({}, opacityInputProps, {
        className: opacityInputClassName,
        disabled: disabled,
        value: opacity,
        onChange: this.handleOpacityInputChange,
        min: 0,
        max: 100,
        formatStyle: "percentage",
        readOnly: readOnly
      }))) : null;

      var renderedColorPickerPanel = this._renderColorPickerPanel(computedColorPicker, open, swatchColor, opacity, this.handleColorChange, this.handleOpenChange, this._triggerEl);

      return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
        className: classes
      }), _react.default.createElement("div", {
        className: "private-color-input__input-wrapper"
      }, _react.default.createElement(_UIFormControl.default, {
        "aria-label": colorInputLabel || 'color input',
        label: colorInputLabel,
        className: (0, _classNames.default)('private-color-input__input', {
          'sr-only': !showInput
        })
      }, renderedHexInput), renderedOpacityInput), _react.default.createElement("div", {
        className: (0, _classNames.default)('private-color-input__trigger', {
          'private-color-input__trigger-hidden': !showInput
        }),
        ref: function ref(elt) {
          _this2._triggerEl = elt;
        }
      }, _react.default.createElement(_UIColorSwatch.default, (0, _extends2.default)({
        borderColor: shouldShowBorder(swatchColor) ? _colors.BATTLESHIP : undefined,
        borderWidth: shouldShowBorder(swatchColor) ? 1 : 0
      }, swatchProps, {
        className: swatchClasses,
        opacity: opacity,
        color: swatchColor,
        onClick: disabled || readOnly ? null : this.handleOpenChange,
        readOnly: disabled || readOnly
      })), _react.default.createElement("div", {
        className: "private-color-input__picker"
      }, renderedColorPickerPanel)));
    }
  }]);
  return UIColorInput;
}(_react.default.Component);

UIColorInput.propTypes = {
  ColorPicker: _react.PropTypes.oneOfType([CustomRenderer.propType, _react.PropTypes.oneOf(['native'])]).isRequired,
  color: Color.propType,
  colorValidator: _react.PropTypes.func.isRequired,
  disabled: _react.PropTypes.bool,
  inputClassName: _react.PropTypes.string,
  inputProps: _react.PropTypes.object,
  onColorChange: _react.PropTypes.func,
  onOpenChange: _react.PropTypes.func,
  open: _react.PropTypes.bool,
  readOnly: _react.PropTypes.bool,
  showInput: _react.PropTypes.bool,
  swatchClassName: _react.PropTypes.string,
  swatchProps: (0, _passthroughProps.default)(_UIColorSwatch.default),
  opacity: _react.PropTypes.number,
  onOpacityChange: _react.PropTypes.func,
  colorInputLabel: _react.PropTypes.string,
  opacityInputLabel: _react.PropTypes.string,
  opacityInputClassName: _react.PropTypes.string,
  opacityInputProps: _react.PropTypes.object
};
UIColorInput.defaultProps = {
  color: DEFAULT_COLOR,
  colorValidator: Color.isValidColorHex,
  open: false,
  ColorPicker: NoopColorPicker,
  readOnly: false,
  showInput: true
};
UIColorInput.displayName = 'UIColorInput';

var _default = (0, _Controllable.default)(UIColorInput, ['color', 'open', 'opacity']);

exports.default = _default;
module.exports = exports.default;